import PropTypes from 'prop-types'
import { Card, CardBody, Flex, Grid, GridItem, Spinner, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { numberFormatter } from 'lib'

export const MetricsComprehensive = ({ isLoading, data, ...rest }) => {
  const navigate = useNavigate()

  if (isLoading) {
    return (
      <Flex alignItems="center" gap={4} {...rest}>
        <Spinner color="blue.400" size="sm" />
        <Text fontSize="sm">Loading ...</Text>
      </Flex>
    )
  } else {
    return (
      <Grid
        templateColumns={{ lg: 'repeat(6, 1fr)', md: 'repeat(3, 1fr)' }}
        gap={4}
        {...rest}
      >
        <GridItem>
          <a
            href='/reporting/metrics/task-due'
            onClick={(e) => {
              e.preventDefault()
              navigate('/reporting/metrics/task-due')
            }}
          >
            <Card
              textAlign="center"
              h="100%"
              onClick={() => navigate('/reporting/metrics/task-due')}
              style={{ cursor: 'pointer' }}
            >
              <CardBody display="flex" flexDirection="column" justifyContent="space-between">
                <Text>Active Projects w/o Task Due</Text>
                <Text fontWeight="bold" fontSize="lg">{data.countTaskDueProjects}</Text>
              </CardBody>
            </Card>
          </a>
        </GridItem>
        <GridItem>
          <a
            href='/reporting/metrics/no-activity'
            onClick={(e) => {
              e.preventDefault()
              navigate('/reporting/metrics/no-activity')
            }}
          >
            <Card
              textAlign="center"
              h="100%"
              onClick={() => navigate('/reporting/metrics/no-activity')}
              style={{ cursor: 'pointer' }}
            >
              <CardBody display="flex" flexDirection="column" justifyContent="space-between">
                <Text>{'Projects w/No Activity >7 days'}</Text>
                <Text fontWeight="bold" fontSize="lg">{data.countNoActivityProjects}</Text>
              </CardBody>
            </Card>
          </a>
        </GridItem>
        <GridItem>
          <Card textAlign="center" h="100%">
            <CardBody display="flex" flexDirection="column" justifyContent="space-between">
              <Text>Previous Month<br/>New Projects</Text>
              <Text fontWeight="bold" fontSize="lg">{data.prevMonthNewProjects.count}<br/>$ {numberFormatter(data.prevMonthNewProjects.amount)}</Text>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem>
          <Card textAlign="center" h="100%">
            <CardBody display="flex" flexDirection="column" justifyContent="space-between">
              <Text>Previous Month<br/>Completed Projects</Text>
              <Text fontWeight="bold" fontSize="lg">{data.prevMonthCompletedProjects.count}<br/>$ {numberFormatter(data.prevMonthCompletedProjects.amount)}</Text>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem>
          <Card textAlign="center" h="100%">
            <CardBody display="flex" flexDirection="column" justifyContent="space-between">
              <Text>Current Month<br/>New Projects</Text>
              <Text fontWeight="bold" fontSize="lg">{data.curMonthNewProjects.count}<br/>$ {numberFormatter(data.curMonthNewProjects.amount)}</Text>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem>
          <Card textAlign="center" h="100%">
            <CardBody display="flex" flexDirection="column" justifyContent="space-between">
              <Text>Current Month<br/>Completed Projects</Text>
              <Text fontWeight="bold" fontSize="lg">{data.curMonthCompletedProjects.count}<br/>$ {numberFormatter(data.curMonthCompletedProjects.amount)}</Text>
            </CardBody>
          </Card>
        </GridItem>
      </Grid>
    )
  }
}

MetricsComprehensive.propTypes = {
  isLoading: PropTypes.bool,
  data: PropTypes.object
}
